import { GoogleReviewData } from "constants/dataTypes";
import { useState } from "react";
import { getRelativeTime } from "utils/common.utils";
import { DetailedReviewPopup } from "./DetailedReviewPopup";
import Image from 'next/image';

export const Review: React.FC<GoogleReviewData> = ({ reviewId, reviewer_displayName, reviewer_profilePhotoUrl, review, starRating, create_date }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
  
    const handleReadMore = () => {
      setIsPopupOpen(true);
    };
  
    const handleClosePopup = () => {
      setIsPopupOpen(false);
    };
  
    return (
        <div key={reviewId} className="flex flex-col space-y-2 rounded border border-[#EAEAEA] p-4 sm:flex-row sm:space-y-0">
 <div className="flex items-start sm:flex-col sm:items-start sm:w-40 sm:flex-shrink-0">
  <div className="bg-gray-300 h-12 w-12 overflow-hidden rounded-full flex-shrink-0">
    <Image
      src={reviewer_profilePhotoUrl}
      alt={reviewer_displayName}
      width={48}
      height={48}
      className="object-cover"
    />
  </div>
  <div className="ml-2 sm:ml-0 sm:mt-2">
    <div className="text-base font-medium">{reviewer_displayName}</div>
    <div className="text-xs text-[#959595]">{getRelativeTime(create_date)}</div>
  </div>
</div>
  <div className="flex-grow">
    <div className="flex items-center mb-2">
      <span className="mr-2 text-sm text-[#959595]">{starRating} out of 5</span>
      <span className="text-[#FBBB06]">★★★★★</span>
    </div>
    <p className="text-[15px]">
      {review.length > 250 ? (
        <>
          {review.slice(0, 250)}... <br />
          <button onClick={handleReadMore} className="text-[#00AEC7]">Read more</button>
        </>
      ) : (
        review
      )}
    </p>
  </div>
  {isPopupOpen && <DetailedReviewPopup review={{ reviewId, reviewer_displayName, reviewer_profilePhotoUrl, review, starRating, create_date }} onClose={handleClosePopup} />}
</div>
    );
  };